import { mapState, mapMutations } from 'vuex'
import { GENERAL_STORE } from '../store'

export default {
  computed: {
    ...mapState(GENERAL_STORE, ['user', 'order', 'base', 'form']),
    paymentCard() {
      if (this.form.deliveryObject) {
        return this.user.cards.find(
          card => Number(this.form.deliveryObject.info.bankCardId) === card.id
        )
      }
    },

    selectedCard: {
      get() {
        return this.order.selectedCard
      },
      set(value) {
        this.updateOrder({
          key: 'selectedCard',
          value,
        })
      },
    },
  },

  methods: {
    ...mapMutations(GENERAL_STORE, ['updateOrder']),
  },

  created() {
    if (!this.selectedCard && this.user.cards.length) {
      if (this.paymentCard !== undefined) {
        this.selectedCard = this.paymentCard
      } else {
        this.selectedCard = this.user.cards[0]
      }
    }
  },
}
